var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n<p>Please select applicable D/B/As</p>\n<form class=\"dba-form form-horizontal\">\n  <div class=\"dbas\"></div>\n</form>";
},"useData":true});